import styled from 'styled-components';

export const CardWrap = styled.div`
  position: relative;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;

  h3 {
    flex: 1;
    min-width: 0;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 0.65rem;
  right: 0.65rem;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition:
    color 0.15s ease,
    background 0.15s ease;

  &:hover {
    color: #b91c1c;
    background: #fef2f2;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const CardMeta = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors?.text?.secondary || '#666'};
`;

export const StepCount = styled(CardMeta)`
  margin-top: 0.5rem;
  display: block;
`;
